import React from 'react';

const Delete = () => (
    <svg width="36px" height="36px" viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="icons/delete" fill="#0852E0">
                <path
                    d="M25.5,12 L25.5,29 C25.5,29.5522847 25.0522847,30 24.5,30 L11.5,30 C10.9477153,30 10.5,29.5522847 10.5,29 L10.5,12 L9,12 L9,10.5 L27,10.5 L27,12 L25.5,12 Z M12,12 L12,28.5 L24,28.5 L24,12 L12,12 Z M15,15 L16.5,15 L16.5,25.5 L15,25.5 L15,15 Z M19.5,15 L21,15 L21,25.5 L19.5,25.5 L19.5,15 Z M13.5,7.5 L13.5,6 L22.5,6 L22.5,7.5 L13.5,7.5 Z"
                    id="Combined-Shape"
                ></path>
            </g>
        </g>
    </svg>
);

export default Delete;
